import { render } from "./DentalVeneersResin.vue?vue&type=template&id=1a6bb6c0"
import script from "./DentalVeneersResin.vue?vue&type=script&lang=js"
export * from "./DentalVeneersResin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__